<template>
  <div>
    <Form label-position="top">
      <FormItem :label="`${typeTitle}类型:`">
        <RadioGroup v-model="dataConfig.userType" @on-change="userTypeChange">
          <Radio :label="1">指定人员</Radio>
          <Radio :label="2">指定部门</Radio>
          <Radio :label="3">指定角色</Radio>
          <Radio :label="4">部门主管</Radio>
          <Radio :label="5">直属主管</Radio>
        </RadioGroup>
      </FormItem>
      <div>
        <div v-show="dataConfig.userType == 1">
          <Button
            :icon="personIsEdit ? 'ios-create' : 'md-add'"
            type="primary"
            @click="openPersonModal"
          >
            {{ personIsEdit ? '修改成员' : '添加成员' }}
          </Button>
          <a class="clearList" @click="clearList('person')">清空</a>
          <selectShowList :list="list.person" @on-delete-item="personDel" />
        </div>
        <div v-show="dataConfig.userType == 2">
          <Button
            :icon="departmentIsEdit ? 'ios-create' : 'md-add'"
            type="primary"
            @click="openDepartmentModal"
          >
            {{ departmentIsEdit ? '修改部门' : '添加部门' }}
          </Button>
          <a class="clearList" @click="clearList('department')">清空</a>
          <selectShowList
            type="department"
            :list="list.department"
            @on-delete-item="departmentDel"
          />
        </div>
        <div v-show="dataConfig.userType == 3">
          <Button
            :icon="roleIsEdit ? 'ios-create' : 'md-add'"
            type="primary"
            @click="openRoleModal"
          >
            {{ roleIsEdit ? '修改角色' : '添加角色' }}
          </Button>
          <a class="clearList" @click="clearList('role')">清空</a>
          <selectShowList :list="list.role" @on-delete-item="roleDel" />
        </div>
        <!-- 如果是部门主管 -->
        <div v-show="dataConfig.userType == 4">
          <FormItem :label="`${typeTitle}的`">
            <Select
              v-model="bmDirector"
              style="width: 200px"
              @on-change="bmDirectorChange"
              transfer
            >
              <Option
                v-for="(item, index) in 20"
                :key="item"
                :value="`${index}`"
              >
                {{ index == 0 ? '直接主管' : `${item}级主管` }}
              </Option>
            </Select>
          </FormItem>
          <Checkbox
            v-if="[1, 3].includes(dataConfig.nodeType)"
            v-model="dataConfig.userNullAutoHighLeaderDepartment"
          >
            <span>找不到主管时，是否由上级主管审批</span>
          </Checkbox>
        </div>
        <!-- 如果是直属主管 -->
        <div v-show="dataConfig.userType == 5">
          <FormItem :label="`${typeTitle}的`">
            <Select
              transfer
              v-model="zsDirector"
              style="width: 200px"
              @on-change="zsDirectorChange"
            >
              <Option
                v-for="(item, index) in 20"
                :key="item"
                :value="`${index}`"
              >
                {{ index == 0 ? '直属主管' : `${item}级主管` }}
              </Option>
            </Select>
          </FormItem>
        </div>
        <!-- 是多人审批时的审批顺序 -->
        <template v-if="needSort && [1, 3].includes(dataConfig.nodeType)">
          <div
            style="margin: 10px 0"
            v-if="[2, 3, 4].includes(dataConfig.userType)"
          >
            <FormItem label="多人审批时的审批顺序:">
              <RadioGroup v-model="dataConfig.execType" vertical>
                <Radio :label="2">会签(需要所有人同意)</Radio>
                <Radio :label="3">或签(一名审批人同意或拒绝即可)</Radio>
              </RadioGroup>
            </FormItem>
          </div>
          <div
            v-if="
              dataConfig.userType == '1' &&
                list.person &&
                list.person.length > 1
            "
          >
            <FormItem label="多人审批时的审批顺序:">
              <RadioGroup v-model="dataConfig.execType" vertical>
                <!-- 如果是办理人的话，就算是多人审批，也不会展示依次审批 -->
                <Radio v-if="dataConfig.nodeType != 3" :label="1">
                  依次审批
                </Radio>
                <Radio :label="2">会签(需要所有人同意)</Radio>
                <Radio :label="3">或签(一名审批人同意或拒绝即可)</Radio>
              </RadioGroup>
            </FormItem>
          </div>
        </template>
        <!-- 审批人为空时处理方式 -->
        <template v-if="[1, 3].includes(dataConfig.nodeType)">
          <div
            v-if="
              needDealwith && dataConfig.userType && dataConfig.userType != '1'
            "
          >
            <FormItem label="审批人为空时处理方式:" style="margin-bottom: 0">
              <RadioGroup v-model="dataConfig.userNullProcType" vertical>
                <Radio :label="1">自动通过</Radio>
                <Radio :label="2">自动转交管理员</Radio>
                <Radio :label="3">指定人员处理</Radio>
              </RadioGroup>
            </FormItem>
            <Button
              :icon="personRadioIsEdit ? 'ios-create' : 'md-add'"
              type="primary"
              v-if="dataConfig.userNullProcType == 3"
              @click="openPersonRadioModal"
            >
              {{ personRadioIsEdit ? '修改成员' : '添加成员' }}
            </Button>
            <selectShowList
              v-if="
                dataConfig.userNullProcType == 3 &&
                  userNullSelUserList.length > 0
              "
              :list="userNullSelUserList"
              @on-delete-item="userNullDel"
            />
          </div>
        </template>
      </div>
    </Form>
    <employees-dialog
      :multiple="true"
      :visible.sync="personVisible"
      :selected="list.person"
      @change="surePerson"
    />
    <departmentDialog
      :multiple="true"
      :selected="list.department"
      :visible.sync="departmentVisible"
      @change="sureDepartment"
    />
    <roleDialog
      :multiple="true"
      :visible.sync="roleVisible"
      :selected="list.role"
      @change="sureRole"
    />
    <personRadioDialog
      :visible.sync="personRadioVisible"
      :selected="userNullSelUserList"
      @change="surePersonRadio"
    />
  </div>
</template>
<script>
import selectShowList from './selectShowList.vue';
import {
  employeesDialog,
  departmentDialog,
  roleDialog,
  personRadioDialog
} from '../dialog';
import { userTypeMap } from './config';
export default {
  name: 'approverInfo',
  components: {
    selectShowList,
    employeesDialog,
    departmentDialog,
    roleDialog,
    personRadioDialog
  },
  props: {
    typeTitle: {
      type: String,
      default: '',
      required: true
    },
    needSort: {
      type: Boolean,
      default: true
    },
    needDealwith: {
      type: Boolean,
      default: true
    },
    dataConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      personVisible: false,
      departmentVisible: false,
      roleVisible: false,
      personRadioVisible: false,
      list: {
        person: [],
        department: [],
        role: []
      },
      userNullSelUserList: [],
      bmDirector: '0',
      zsDirector: '0'
    };
  },
  computed: {
    personIsEdit() {
      return this.list.person && this.list.person.length > 0;
    },
    departmentIsEdit() {
      return this.list.department && this.list.department.length > 0;
    },
    roleIsEdit() {
      return this.list.role && this.list.role.length > 0;
    },
    personRadioIsEdit() {
      return this.userNullSelUserList && this.userNullSelUserList.length > 0;
    }
  },
  methods: {
    openPersonModal() {
      this.personVisible = true;
    },
    openDepartmentModal() {
      this.departmentVisible = true;
    },
    openRoleModal() {
      this.roleVisible = true;
    },
    openPersonRadioModal() {
      this.personRadioVisible = true;
    },
    personDel(deleteItem) {
      const { id } = deleteItem;
      const list = this.list.person;
      const newList = list.filter(i => i.id != id);
      this.list = { ...this.list, person: [...newList] };
    },
    departmentDel(deleteItem) {
      const { relationId } = deleteItem;
      const list = this.list.department;
      const newList = list.filter(i => i.relationId != relationId);
      this.list = { ...this.list, department: [...newList] };
    },
    roleDel(deleteItem) {
      const { id } = deleteItem;
      const list = this.list.role;
      const newList = list.filter(i => i.id != id);
      this.list = { ...this.list, role: [...newList] };
    },
    userNullDel() {
      this.userNullSelUserList = [];
    },
    clearList(type) {
      this.list = { ...this.list, [type]: [] };
    },
    surePerson(data) {
      this.list = { ...this.list, person: data };
      this.personVisible = false;
    },
    sureDepartment(data) {
      this.list = { ...this.list, department: data };
      this.departmentVisible = false;
    },
    sureRole(data) {
      this.list = { ...this.list, role: data };
      this.roleVisible = false;
    },
    surePersonRadio(data) {
      this.userNullSelUserList = data;
      this.personRadioVisible = false;
    },
    userTypeChange(value) {
      const { nodeExecUsersName } = userTypeMap[value];
      const { execType } = this.dataConfig;
      if ([1, 2, 3].includes(value)) {
        const ids = this.list[nodeExecUsersName].map(item => {
          // 当是部门的时候，后端要 relationId
          return value == 2 ? item.relationId : item.id;
        });
        this.dataConfig.nodeExecUsers = ids;
        this.dataConfig.nodeUserList = this.list[nodeExecUsersName];
        // 给出默认值
        /**
         * 如果是指定人员，不管选择的人员是否大于1，都将 exectype 置为 1;
         * 如果是部门或者角色时 如果是1 或为空的话，置为2 ，如果不是就置为exectype
         */
        if (value == 1 && !this.dataConfig.execType) {
          this.dataConfig.execType = 1;
        }
        if ([2, 3].includes(value)) {
          this.dataConfig.execType = execType == 1 || !execType ? 2 : execType;
        }
        return true;
      }
      // 如果是部门主管或者是直属主管的时候，把会签或者或签都给一下默认值
      if (value == 4) {
        // 如果是直属主管
        if (execType == 1 || !execType) {
          this.dataConfig.execType = 2;
        }
      }
      if (value == 5) {
        this.dataConfig.execType = 1;
      }
      this.dataConfig.nodeExecUsers = [this[nodeExecUsersName]];
      this.dataConfig.nodeUserList = [];
    },
    bmDirectorChange(value) {
      if (this.dataConfig.userType == 4) {
        this.dataConfig.nodeExecUsers = [value];
      }
    },
    zsDirectorChange(value) {
      if (this.dataConfig.userType == 5) {
        this.dataConfig.nodeExecUsers = [value];
      }
    }
  },
  created() {
    const { userType, userNullProcType, userNullSelUserList } = this.dataConfig;
    if (!userNullProcType) {
      this.dataConfig.userNullProcType = 1;
    }
    if (userNullProcType == 3) {
      this.userNullSelUserList = userNullSelUserList || [];
    }
    const { nodeExecUsersName } = userTypeMap[userType];
    if ([1, 2, 3].includes(userType)) {
      this.list = {
        ...this.list,
        [nodeExecUsersName]: this.dataConfig.nodeUserList
      };
      return true;
    }
    this[nodeExecUsersName] = this.dataConfig.nodeExecUsers[0] || '0';
  }
};
</script>
<style lang="less" scoped>
.clearList {
  margin: 0 10px;
}
</style>
